/* DGA-brand homepage: scroll-animaties en carrousel-pijlen. */
(function () {
  if (window.__dgbInit) return;
  window.__dgbInit = true;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.dgb-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dgb-scroll]');
    if (!btn) return;
    var rail = document.getElementById(btn.getAttribute('data-dgb-target'));
    if (!rail) return;
    var dir = parseInt(btn.getAttribute('data-dgb-scroll'), 10) || 1;
    var card = rail.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 20 : 320;
    rail.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reveal(); });
  } else {
    reveal();
  }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
